/* istanbul ignore file */
import Header from './Header';

export default Header;
